var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"status__template"},[_c('Spiner'),_c('section',[_c('h3',[_vm._v(_vm._s(_vm.$t("descriptions.search_account_data")))]),_c('small',[_vm._v(_vm._s(_vm.$t("descriptions.please_wait_moment"))+"...")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }